"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var EscPosConnectorsApi = /** @class */ (function (_super) {
    __extends(EscPosConnectorsApi, _super);
    function EscPosConnectorsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Use this endpoint to create a new `EscPosConnector`. You\'ll need to create a new `EscPosConnector` for each printer you want to connect to Trybe.  Credentials for this resource will be emailed to the authenticated user upon a successful request.  Please note, we\'ll be performing some asynchronous provisioning when you create an `EscPosConnector`. You won\'t be able to use the credentials until provisioning is complete. This won\'t take longer than 10 minutes.  Provisioning status is outputted in the `provision_status` field. You may poll the [showEscPosConnector](#showEscPosConnector) endpoint in line with our rate limits to determine when provisioning is complete.
     * Create an EscPosConnector
     */
    EscPosConnectorsApi.prototype.createEscPosConnectorRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/esc-pos-connectors",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateEscPosConnectorToJSON(requestParameters.createEscPosConnector),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowEscPosConnectorFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to create a new `EscPosConnector`. You\'ll need to create a new `EscPosConnector` for each printer you want to connect to Trybe.  Credentials for this resource will be emailed to the authenticated user upon a successful request.  Please note, we\'ll be performing some asynchronous provisioning when you create an `EscPosConnector`. You won\'t be able to use the credentials until provisioning is complete. This won\'t take longer than 10 minutes.  Provisioning status is outputted in the `provision_status` field. You may poll the [showEscPosConnector](#showEscPosConnector) endpoint in line with our rate limits to determine when provisioning is complete.
     * Create an EscPosConnector
     */
    EscPosConnectorsApi.prototype.createEscPosConnector = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createEscPosConnectorRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to delete an `EscPosConnector`.  This is an asynchronous operation. The `EscPosConnector` will be deleted in the background and should take around 2 minutes.  The endpoint will return a 204 immediately and the status of the connector will be updated to `deleting`.  Once the operation is complete, the `EscPosConnector` will be removed and you\'ll receive a 404 when attempting to retrieve it.
     * Delete an EscPosConnector
     */
    EscPosConnectorsApi.prototype.deleteEscPosConnectorRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.escPosConnector === null || requestParameters.escPosConnector === undefined) {
                            throw new runtime.RequiredError('escPosConnector', 'Required parameter requestParameters.escPosConnector was null or undefined when calling deleteEscPosConnector.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/esc-pos-connectors/{escPosConnector}".replace("{" + "escPosConnector" + "}", encodeURIComponent(String(requestParameters.escPosConnector))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Use this endpoint to delete an `EscPosConnector`.  This is an asynchronous operation. The `EscPosConnector` will be deleted in the background and should take around 2 minutes.  The endpoint will return a 204 immediately and the status of the connector will be updated to `deleting`.  Once the operation is complete, the `EscPosConnector` will be removed and you\'ll receive a 404 when attempting to retrieve it.
     * Delete an EscPosConnector
     */
    EscPosConnectorsApi.prototype.deleteEscPosConnector = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteEscPosConnectorRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves an `EscPosConnector` by ID.
     * Show an EscPosConnector
     */
    EscPosConnectorsApi.prototype.getEscPosConnectorRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.escPosConnector === null || requestParameters.escPosConnector === undefined) {
                            throw new runtime.RequiredError('escPosConnector', 'Required parameter requestParameters.escPosConnector was null or undefined when calling getEscPosConnector.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/esc-pos-connectors/{escPosConnector}".replace("{" + "escPosConnector" + "}", encodeURIComponent(String(requestParameters.escPosConnector))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowEscPosConnectorFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves an `EscPosConnector` by ID.
     * Show an EscPosConnector
     */
    EscPosConnectorsApi.prototype.getEscPosConnector = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEscPosConnectorRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint lists the `EscPosConnector`s which are associated to the provided site.
     * List EscPosConnectors
     */
    EscPosConnectorsApi.prototype.listEscPosConnectorsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/esc-pos-connectors",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListEscPosConnectorsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint lists the `EscPosConnector`s which are associated to the provided site.
     * List EscPosConnectors
     */
    EscPosConnectorsApi.prototype.listEscPosConnectors = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listEscPosConnectorsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates an `EscPosConnector` by ID.
     * Update an EscPosConnector
     */
    EscPosConnectorsApi.prototype.updateEscPosConnectorRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.escPosConnector === null || requestParameters.escPosConnector === undefined) {
                            throw new runtime.RequiredError('escPosConnector', 'Required parameter requestParameters.escPosConnector was null or undefined when calling updateEscPosConnector.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/esc-pos-connectors/{escPosConnector}".replace("{" + "escPosConnector" + "}", encodeURIComponent(String(requestParameters.escPosConnector))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateEscPosConnectorToJSON(requestParameters.updateEscPosConnector),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowEscPosConnectorFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates an `EscPosConnector` by ID.
     * Update an EscPosConnector
     */
    EscPosConnectorsApi.prototype.updateEscPosConnector = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateEscPosConnectorRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return EscPosConnectorsApi;
}(runtime.BaseAPI));
exports.EscPosConnectorsApi = EscPosConnectorsApi;
